export enum CONFIGURATION_CONSTANT {
  CHECK_IN_TIME = 'CHECK_IN_TIME',
  EMERGENCY_CHECK_IN_TIME = 'EMERGENCY_CHECK_IN_TIME',
  EMERGENCY_GPS_UPDATE_COUNT = 'EMERGENCY_GPS_UPDATE_COUNT',
  HEART_RATE_ENABLED = 'HEART_RATE_ENABLED',
  GPS_ENABLED = 'GPS_ENABLED',
  LTE_SIGNAL_STRENGTH_ENABLED = 'LTE_SIGNAL_STRENGTH_ENABLED',
  SIGNAL_STRENGTH_ENABLED = 'SIGNAL_STRENGTH_ENABLED',
  FALL_DETECTION_ENABLED = 'FALL_DETECTION_ENABLED',
  FALL_DETECTION = 'FALL_DETECTION',
  BATTERY_STATUS_ENABLED = 'BATTERY_STATUS_ENABLED',
  KIOSK_MODE_ENABLED = 'KIOSK_MODE_ENABLED',
  RAPID_RESPONSE_CONTACT_PHONE = 'RAPID_RESPONSE_CONTACT_PHONE',
  RAPID_RESPONSE_CONTACT_URL = 'RAPID_RESPONSE_CONTACT_URL',
  LOW_BATTERY_THRESHOLD = 'LOW_BATTERY_THRESHOLD',
  ADMIN_ESCALATION_ENABLED = 'ADMIN_ESCALATION_ENABLED',
  ADMIN_ESCALATION_DELAY = 'ADMIN_ESCALATION_DELAY',
  NO_PACKET_THRESHOLD = 'NO_PACKET_THRESHOLD',
  NOT_WORN_THRESHOLD = 'NOT_WORN_THRESHOLD',
  MISSING_GPS_CONSECUTIVE_COOLDOWN = 'MISSING_GPS_CONSECUTIVE_COOLDOWN',
  WATCH_THEME = 'WATCH_THEME',
}

export const CONFIGURATION_TYPE_CONSTANT = {
    STRING: 'String',
    UNIT: 'Unit',
    BOOLEAN: 'Boolean',
    NUMBER: 'Number',
    DATE: 'Date',
    DATETIME: 'DateTime',
}

export const NEXION_SUPER_ADMIN_EMAIL = 'nexion@noveltytechnology.com';
